import axios from 'axios';
import appConfig from '../../configs/app.config';
import { requestInterceptor } from '../interceptors/request';
import { responseInterceptor, createResponseErrorInterceptor } from '../interceptors/response';

const client = axios.create({
  baseURL: appConfig.apiBaseUrl,
  timeout: 30000,
  headers: {
    'Content-Type': 'application/json',
  },
});

client.interceptors.request.use(requestInterceptor, (error) => Promise.reject(error));
client.interceptors.response.use(responseInterceptor, createResponseErrorInterceptor(client));

export default client;
